import { render, staticRenderFns } from "./systemname.vue?vue&type=template&id=455356ca"
import script from "./systemname.vue?vue&type=script&lang=ts"
export * from "./systemname.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports